<template>
  <div class="page-container">
    <Header></Header>
    
    <div class="main-layout">
      <div class="sidebar">
        <MenuList></MenuList>
      </div>
      
      <div class="content">
        <!-- 操作栏 -->
        <div class="action-bar">
          <el-button type="primary" plain size="small" @click="backToList">
            <i class="el-icon-arrow-left"></i>返回列表
          </el-button>
          <div class="action-right">
            <el-tooltip effect="dark" content="给填写列增加填写要求,规范数据填写" placement="bottom">
              <el-button type="primary" size="small" @click="showAddCommentTips">
                <i class="el-icon-document-add"></i>添加填写要求
              </el-button>
            </el-tooltip>
          </div>
        </div>
        
        <!-- 表格信息卡片 -->
        <div class="info-card">
          <h2 class="form-title">{{form_name}}</h2>
          <div class="form-meta">
            <span class="meta-item">
              <i class="el-icon-search"></i>
              <span>领表查询条件：<strong>{{showConditions()}}</strong></span>
            </span>
            <el-button type="text" size="small" @click="resetQueryCondition" class="reset-link">
              <i class="el-icon-refresh"></i>重新设置查询条件
            </el-button>
          </div>
        </div>
        
        <!-- 数据表格 -->
        <div class="table-container">
          <el-table 
            ref="dataList" 
            :data="dataList" 
            stripe 
            class="data-table"
            :header-cell-style="{background:'#f5f7fa',color:'#606266',fontWeight:'600'}"
            v-loading="loading"
            height="500">
            
            <el-table-column 
              v-for="(header) in headers" 
              :key="header.prop"
              :prop="header.prop"
              :label="header.label"
              header-align="center" 
              align="center"
              resizable>
              <template slot="header" slot-scope="scope">
                <div v-if="header.can_edit=='1'" class="editable-header">
                  <div class="header-main red-text">{{header.label}}</div>
                  <div class="header-type">【{{header.type}}】</div>
                  <div class="header-comment" v-if="header.comment">{{header.comment}}</div>
                </div>
                <div v-else class="normal-header">
                  <span v-if="header.is_condition=='1'" class="condition-tag">
                    <i class="el-icon-search"></i>{{header.label}}
                  </span>
                  <span v-else>{{header.label}}</span>
                </div>
              </template>
              
              <template slot-scope="scope">
                <div v-if="header.type=='图片'" class="media-link">
                  <span v-if="isValidURL(getImageFileUrl(scope.row[header.prop]))">
                    <el-button type="text" size="small" @click="openUrl(getImageFileUrl(scope.row[header.prop]))">
                      <i class="el-icon-picture-outline"></i>查看图片
                    </el-button>
                  </span>
                  <span v-else class="empty-text">-</span>
                </div>
                
                <div v-else-if="header.type=='签名'" class="media-link">
                  <el-button type="text" size="small" @click="openUrl(getImageFileUrl(scope.row[header.prop]))">
                    <i class="el-icon-edit"></i>查看签名
                  </el-button>
                </div>
                
                <div v-else-if="header.type=='视频'" class="media-link">
                  <el-button type="text" size="small" @click="openUrl(getImageFileUrl(scope.row[header.prop]))">
                    <i class="el-icon-video-play"></i>观看视频
                  </el-button>
                </div>
                
                <div v-else class="cell-text">
                  {{scope.row[header.prop] || '-'}}
                </div>
              </template>
            </el-table-column>
            
            <!-- <el-table-column fixed="right" align="center" label="操作" width="100">
              <template slot-scope="scope">
                <el-button @click="deleteRecord(scope.row)" type="text" size="small" class="delete-btn">
                  <i class="el-icon-delete"></i>删除
                </el-button>
              </template>
            </el-table-column> -->
          </el-table>
          
          <div class="table-footer">
            <span class="data-count">共 <strong>{{dataList.length}}</strong> 条数据</span>
          </div>
        </div>
        
        <!-- 图例说明 -->
        <div class="legend-bar">
          <span class="legend-item red">
            <i class="el-icon-edit"></i>红色字体列表示需要修改和填写的列
          </span>
          <span class="legend-item">
            <i class="el-icon-search"></i>表示领表时需要输入的内容
          </span>
          <span class="legend-item">
            【xx】表示该列的数据格式
          </span>
        </div>
      </div>
    </div>

    <!-- 添加填写要求弹窗 -->
    <el-dialog 
      title="数据填写要求" 
      :close-on-click-modal="false" 
      :visible.sync="editFieldCommentDialogVisible" 
      width="450px"
      custom-class="custom-dialog">
      <div class="dialog-content">
        <p class="dialog-tip">给 <strong class="highlight">{{editFieldName}}</strong> 列添加填写要求</p>
        <el-input 
          type="textarea" 
          :rows="4" 
          v-model="editFieldComment" 
          placeholder="请说明该列如何填写以及填写格式要求">
        </el-input>
      </div>
      <div slot="footer">
        <el-button @click="editFieldCommentDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="editFieldCommentSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MenuList from './menu.vue'
import Header from './head.vue'

export default {
  components: {
    MenuList,
    Header
  },
  data() {
    return {
      form_id: '',
      form_name: '',
      dataList: [],
      headers: [],
      conditions: [],
      loading: false,
      editFieldCommentDialogVisible: false,
      editFieldName: '',
      editFieldComment: ''
    }
  },
  created() {
    this.username = this.$session.get('USERNAME')
    this.form_id = this.$route.params.form_id
    this.form_name = this.$route.params.form_name
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      let that = this
      var requestUrl = '/checking/web/_load_query_all_data.jsp'
      this.axios.get(requestUrl, {
        params: { form_id: that.form_id }
      }).then(function(response) {
        that.dataList = response.data.dataList
        that.headers = response.data.headers
        that.conditions = response.data.conditions
        that.loading = false
      }).catch(function(error) {
        console.log(error)
        that.loading = false
      })
    },
    deleteRecord(row) {
      var data_row_id = row.data_row_id
      this.$confirm('此操作将永久删除该行, 要删除吗?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteRow(data_row_id)
      }).catch(() => {})
    },
    deleteRow(data_row_id) {
      this.loading = true
      let that = this
      var requestUrl = '/checking/web/_delete_row_by_data_row_id.jsp'
      this.axios.get(requestUrl, {
        params: { data_row_id: data_row_id }
      }).then(function() {
        that.$message.success('删除成功!')
        that.loading = false
        that.loadData()
      }).catch(function(error) {
        console.log(error)
        that.loading = false
      })
    },
    backToList() {
      this.$router.push('/query_list')
    },
    getImageFileUrl(field_value) {
      var url = ''
      if (field_value && field_value.indexOf('"]') > 0) {
        url = field_value.replace('["', '')
        url = url.replace('"]', '')
      }
      return url
    },
    isValidURL(str) {
      if (str) {
        if (str.indexOf('http://') >= 0 || str.indexOf('https://') >= 0) {
          return true
        }
      }
      return false
    },
    resetQueryCondition() {
      this.$router.push({
        name: 'reset_query_conditions',
        params: {
          form_id: this.form_id,
          form_name: this.form_name,
          page_from: 'browse_all_data'
        }
      })
    },
    showConditions() {
      if (this.conditions.length == 0) {
        return '无'
      } else if (this.conditions.length == 1) {
        return this.conditions[0].condition_name
      } else if (this.conditions.length == 2) {
        return this.conditions[0].condition_name + '，' + this.conditions[1].condition_name
      }
      return this.conditions.map(c => c.condition_name).join('，')
    },
    showAddCommentTips() {
      this.$alert('点击红色的表头（可填写的列）可以给该列添加填写要求。填写要求中可以说明该列如何填写以及填写格式。', '提示', {
        confirmButtonText: '知道了'
      })
    },
    clickHeader(column) {
      var pStr = column.property
      this.editFieldName = ''
      for (var i = 0; i < this.headers.length; i++) {
        if (pStr == this.headers[i].label) {
          if (this.headers[i].can_edit == '1') {
            this.editFieldName = pStr
            this.editFieldComment = this.headers[i].comment || ''
            this.editFieldCommentDialogVisible = true
          } else {
            this.$message.error('“' + this.headers[i].label + '”列不需要填表人填写，无需添加填写要求！')
          }
          break
        }
      }
    },
    editFieldCommentSave() {
      this.loading = true
      let that = this
      var requestUrl = '/checking/web/_update_field_comment.jsp'
      this.axios.get(requestUrl, {
        params: {
          form_id: this.form_id,
          field_name: this.editFieldName,
          field_comment: this.editFieldComment
        }
      }).then(function() {
        that.$message.success('保存成功！')
        that.editFieldCommentDialogVisible = false
        that.editFieldComment = ''
        that.loading = false
        that.loadData()
      }).catch(function(error) {
        console.log(error)
        that.loading = false
      })
    },
    openUrl(url) {
      window.open(url)
    }
  }
}
</script>

<style scoped>
.page-container {
  min-height: 100vh;
  background: #f5f7fa;
  display: flex;
  flex-direction: column;
}

.main-layout {
  flex: 1;
  display: flex;
}

.sidebar {
  width: 220px;
  background: #fff;
  border-right: 1px solid #e8ecf1;
  flex-shrink: 0;
}

.content {
  flex: 1;
  padding: 20px;
  overflow: auto;
}

/* 操作栏 */
.action-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.action-right {
  display: flex;
  gap: 12px;
}

/* 信息卡片 */
.info-card {
  background: #fff;
  border-radius: 8px;
  padding: 20px 24px;
  margin-bottom: 16px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
}

.form-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0 0 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.form-meta {
  display: flex;
  align-items: center;
  gap: 20px;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
}

.meta-item i {
  color: #1485FB;
  font-size: 16px;
}

.meta-item strong {
  color: #333;
  font-weight: 600;
}

.reset-link {
  color: #1485FB;
}

.reset-link i {
  margin-right: 4px;
}

/* 表格容器 */
.table-container {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  margin-bottom: 16px;
}

.data-table {
  width: 100%;
}

/* 表头样式 */
.editable-header {
  cursor: pointer;
  padding: 4px;
}

.editable-header:hover {
  background: rgba(245, 108, 108, 0.1);
  border-radius: 4px;
}

.red-text {
  color: #f56c6c;
  font-weight: 600;
}

.header-main {
  font-size: 14px;
  margin-bottom: 2px;
}

.header-type {
  font-size: 12px;
  color: #f56c6c;
  margin-bottom: 2px;
}

.header-comment {
  font-size: 11px;
  color: #e6a23c;
  line-height: 1.3;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.normal-header {
  font-size: 14px;
}

.condition-tag {
  color: #1485FB;
  font-weight: 500;
}

.condition-tag i {
  margin-right: 4px;
}

/* 单元格内容 */
.cell-text {
  font-size: 13px;
  color: #333;
  padding: 4px;
}

.media-link {
  padding: 4px;
}

.empty-text {
  color: #999;
}

.delete-btn {
  color: #f56c6c;
}

.delete-btn:hover {
  color: #ff7875;
}

/* 表格底部 */
.table-footer {
  text-align: center;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
  margin-top: 8px;
}

.data-count {
  font-size: 14px;
  color: #666;
}

.data-count strong {
  color: #1485FB;
  font-size: 16px;
  margin: 0 4px;
}

/* 图例说明 */
.legend-bar {
  background: #fff;
  border-radius: 8px;
  padding: 16px 24px;
  display: flex;
  justify-content: center;
  gap: 40px;
  flex-wrap: wrap;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
}

.legend-item {
  font-size: 13px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 6px;
}

.legend-item.red {
  color: #f56c6c;
}

.legend-item i {
  font-size: 14px;
}

/* 弹窗样式 */
::v-deep .custom-dialog .el-dialog__header {
  background: linear-gradient(135deg, #1485FB 0%, #0066CC 100%);
  padding: 16px 20px;
}

::v-deep .custom-dialog .el-dialog__title {
  color: white;
  font-size: 16px;
  font-weight: 500;
}

::v-deep .custom-dialog .el-dialog__headerbtn .el-dialog__close {
  color: white;
}

.dialog-content {
  padding: 10px 0;
}

.dialog-tip {
  color: #666;
  margin-bottom: 16px;
  font-size: 14px;
}

.dialog-tip .highlight {
  color: #1485FB;
  font-weight: 600;
}

/* 响应式 */
@media (max-width: 768px) {
  .sidebar {
    display: none;
  }
  
  .content {
    padding: 12px;
  }
  
  .action-bar {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }
  
  .form-meta {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .legend-bar {
    flex-direction: column;
    gap: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/browse_all_data.vue